import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './styles/index.css';
import './styles/style.css'; 

// 🟢 إنشاء كائن QueryClient مع تفعيل الكاش الحقيقي
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,      // البيانات تُعتبر "جديدة" لمدة دقيقة
      gcTime: 5 * 60 * 1000,     // الاحتفاظ بالبيانات في الكاش لمدة 5 دقائق
      refetchOnWindowFocus: false, // منع التحديث التلقائي عند التبديل بين نوافذ المتصفح
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);